import { Button, Flex, Heading, showAlertModalError } from '@conteg/ui';
import Error from 'components/error/error';
import Notification from 'components/notification/notification';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useResendAccessCodeMutation } from 'types/generated/graphql';
import { usePoint } from 'utils/device/device-store';

const ResendAccessCode = ({ reservationId }: { reservationId: string }) => {
  const { t } = useTranslation();
  const {
    mutateAsync: resendAccessCode,
    isPending,
    error,
  } = useResendAccessCodeMutation();
  const { pointId } = usePoint();

  const [formNotice, setFormNotice] = useState<string>('');

  const handleResend = () => {
    setFormNotice('');
    resendAccessCode(
      {
        pointId: pointId as string,
        reservationId,
      },
      {
        onSuccess: () => {
          setFormNotice('Page.StorageUnit.Actions.ResendAccessCode.Success');
        },
        onError: (error) => {
          showAlertModalError(
            t('Page.StorageUnit.Actions.ResendAccessCode.Error'),
            error
          );
        },
      }
    );
  };

  if (error) {
    return <Error message="Error.DataFetchFailed" />;
  }

  return (
    <Flex flexDirection="column" gap="6rem" alignItems="center" mt="6rem">
      {formNotice && (
        <Notification
          testId="resend-access-code-notification"
          message={formNotice}
        />
      )}
      <Heading
        variant="h2"
        title={t('Page.StorageUnit.Actions.ResendAccessCode.Heading')}
      />
      <Button
        testId="resend-button"
        variant="primary"
        size="xl"
        title={t('Page.StorageUnit.Actions.ResendAccessCode.Send')}
        disabled={isPending}
        onClick={handleResend}
      />
    </Flex>
  );
};

export default ResendAccessCode;
